import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "gfu-layout__main gfu-layout__main--extranarrow" }
const _hoisted_2 = { class: "gfu-hd gfu-hd--h1 _mt-6 _mb-5" }
const _hoisted_3 = {
  key: 0,
  class: "gfu-card-list gfu-card-list--wrap _-mt-3"
}
const _hoisted_4 = {
  class: "_mt-3",
  "data-qa": "user-profile:EmptyState"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_button = _resolveComponent("base-button")
  const _component_empty_state = _resolveComponent("empty-state")
  const _component_box = _resolveComponent("box")
  const _component_load_more_trigger = _resolveComponent("load-more-trigger")
  const _component_progress_overlay = _resolveComponent("progress-overlay")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.Resources.Profile.SectionProjectsHeader), 1 /* TEXT */),
    (_ctx.hasPagedItems)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.mappedPagedItems, (project) => {
            return (_openBlock(), _createElementBlock("div", {
              key: project.projectID,
              class: "gfu-card-list__item gfu-1of1 gfu-1of2--m gfu-1of3--l"
            }, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(project.component), _mergeProps({ ref_for: true }, project.props), null, 16 /* FULL_PROPS */))
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
      : (_openBlock(), _createBlock(_component_box, { key: 1 }, {
          default: _withCtx(() => [
            _createVNode(_component_empty_state, {
              title: _ctx.Resources.Profile.EmptyStateProjectsTitle
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, _toDisplayString($options.emptyStateMessage), 1 /* TEXT */),
                ($props.isViewingOwnProfile)
                  ? (_openBlock(), _createBlock(_component_base_button, {
                      key: 0,
                      tag: "a",
                      href: $options.searchUrl,
                      class: "_mt-3",
                      theme: "accent",
                      "data-qa": "user-profile-projects:Explore"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.Resources.Profile.EmptyStateProjectsExploreAction), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["href"]))
                  : _createCommentVNode("v-if", true)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["title"])
          ]),
          _: 1 /* STABLE */
        })),
    (_ctx.hasMorePagedItems)
      ? (_openBlock(), _createBlock(_component_load_more_trigger, {
          key: 2,
          onLoadMore: $options.onLoadMore
        }, null, 8 /* PROPS */, ["onLoadMore"]))
      : _createCommentVNode("v-if", true),
    _createVNode(_component_progress_overlay, { visible: _ctx.isProcessing }, null, 8 /* PROPS */, ["visible"])
  ]))
}